import { useEffect, useState } from 'react';
import { Modal, Space, Spin, Table, Tooltip, Typography } from 'antd';
import { CarryOutOutlined, DeleteOutlined, ExclamationCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

import Notification from '../../components/controls/Notification';
import { CaseStudyAPI } from '../../utils/Api';
import ErrorHandler from '../../utils/ErrorHandler';

const { Title } = Typography;
const { confirm } = Modal;

const CaseStudyList = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [caseStudyList, setCaseStudyList] = useState([]);

  useEffect(() => {
    getCaseStudyList();
  }, []);

  const getCaseStudyList = () => {
    setLoading(true);
    CaseStudyAPI.get('/question/admin', { headers: { Authorization: `Bearer ${localStorage.getItem('at')}` } })
      .then((res) => {
        setCaseStudyList(res.data.data?.map((el, i) => ({ ...el, key: i })));
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ErrorHandler(err?.response?.data?.message, history);
        } else {
          Notification('Something went wrong! Please try again later', 'error');
        }
      })
      .finally(() => setLoading(false));
  };

  const deleteCaseStudy = (value) => {
    console.log(value);
    confirm({
      title: 'Are you sure delete this case study?',
      icon: <ExclamationCircleOutlined />,
      content: "Once deleted you won't be able to recover your case study. ",
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'No',

      onOk() {
        CaseStudyAPI.patch('/question/delete', { id: value.id }, { headers: { Authorization: `Bearer ${localStorage.getItem('at')}` } })
          .then(() => {
            setCaseStudyList([...caseStudyList.filter((el) => el.id !== value.id)]);

            Notification('Case study deleted successfully', 'success');
          })
          .catch((err) => {
            if (err?.response?.data?.message) {
              ErrorHandler(err?.response?.data?.message, history);
            } else {
              Notification('Some went wrong deleting this case study. Please try again later', 'error');
            }
          });
      },
    });
  };

  const columns = [
    {
      title: 'HPI',
      dataIndex: 'hpi',
      key: 'hpi',
    },
    {
      title: 'Labs',
      dataIndex: 'labs',
      key: 'labs',
    },
    {
      title: 'Vitals',
      dataIndex: 'vitals',
      key: 'vitals',
    },
    {
      title: 'Modality',
      dataIndex: 'modality',
      key: 'modality',
    },
    {
      title: 'Dicom',
      dataIndex: 'json_url',
      key: 'json_url',
      render: (text) => (
        <Tooltip title='Open DICOM'>
          <a href={text} target='_blank'>
            {text && <CarryOutOutlined />}
          </a>
        </Tooltip>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          {!record.json_url && (
            <Tooltip title='Add Dicom'>
              <PlusCircleOutlined onClick={() => history.push(`/case-study/details/${record.id}`)} />
            </Tooltip>
          )}
          <DeleteOutlined style={{ color: 'red' }} onClick={() => deleteCaseStudy(record)} />
        </Space>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <Title level={2} className='center'>
        Case Study List
      </Title>

      <Table columns={columns} dataSource={caseStudyList} scroll={{ x: 1000 }} />
    </Spin>
  );
};

export default CaseStudyList;
